//import "@/assets/scss/styles.scss";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import VWave from "v-wave";
import Vue from "vue";
import ToastedPlugin from "vue-toasted";

import { envDirective } from "@/directives/env";
import { targetBlankDirective } from "@/directives/target-blank";
import { touchDirective } from "@/directives/touch";
import { formatDate } from "@/filters/format-date";
import { formatDatetime } from "@/filters/format-datetime";
import { serviceMenuStatus } from "@/filters/service-menu-status";
import { deviceService } from "@/services";
import { ApiService } from "@/services/api.service";
import { DeviceService } from "@/services/device.service";
import { ServiceService } from "@/services/service.service";

import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueI18n from 'vue-i18n';
import { createI18n, castToVueI18n } from 'vue-i18n-bridge';
import i18nConfig from '@/langs/i18nConfig';

import { rootStore } from "./store";

require("@/assets/scss/styles.scss");

dayjs.extend(utc);
dayjs.extend(timezone);

Vue.config.productionTip = false;
Vue.use(VWave);
Vue.use(ToastedPlugin, {
  className: "fj-toast",
});

Vue.use(VueI18n, { bridge: true })
const i18n = castToVueI18n(createI18n(i18nConfig, VueI18n))
export default i18n;
Vue.use(i18n)  

Vue.directive("fj-env", envDirective);
Vue.directive("fj-touch", touchDirective);
Vue.directive("target-blank", targetBlankDirective);
Vue.filter("formatDate", formatDate);
Vue.filter("formatDatetime", formatDatetime);
Vue.filter("serviceMenuStatus", serviceMenuStatus);

Vue.prototype.$api = new ApiService();
Vue.prototype.$device = deviceService;
Vue.prototype.$service = new ServiceService();
Vue.prototype.showLoading = function (): void {
  this.$store.commit("globalLoading/show");
};
Vue.prototype.hideLoading = function (): void {
  this.$store.commit("globalLoading/hide");
};
Vue.prototype.hideLoadingIfNoOthers = function (): void {
  this.$store.commit("globalLoading/hideIfNoOthers");
};
Vue.prototype.errorToast = function (text: string): void {
  const toast = this.$toasted.show(text);
  const onClick = () => {
    toast.goAway(0);
    toast.el.removeEventListener("click", onClick);
  };
  toast.el.addEventListener("click", onClick);
};

declare module "vue/types/vue" {
  interface Vue {
    $api: ApiService;
    $device: DeviceService;
    $service: ServiceService;
    showLoading: () => void;
    hideLoading: () => void;
    hideLoadingIfNoOthers: () => void;
    errorToast: (text: string) => void;
  }
}

new Vue({
  router,
  vuetify,
  i18n,
  store: rootStore,
  render: (h) => h(App),
}).$mount("#app");
